import { useQuery } from '@tanstack/react-query';
import { getUnitTypes } from '../query';
export const useUnitTypes = () => {
    return useQuery({
        queryKey: ['unit-types'],
        queryFn: () => getUnitTypes(),
    });
};
export const buildUnitTypesQuery = () => ({
    queryKey: ['unit-types'],
    queryFn: () => getUnitTypes(),
});
